export const processZATCAInvoice = (tenantId, data, token) => {
  return fetch(
    `https://api-pos.hulmsolutions.com/api/fatoora/${tenantId}/process-json`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (token || "my-token"),
      },
      body: JSON.stringify(data),
    }
  ).then((response) => response.json());
};

export const getZatcaInformation = (companyName, token) => {
  return fetch(
    `https://api-pos.hulmsolutions.com/api/fatoora/${companyName}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (token || "my-token"),
      },
    }
  ).then((response) => {
    if (response.ok) {
      return response.json();
    } else if (response.status === 404) {
      // User doesn't exist yet
      return null;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  });
};
